import client from './client';

export const releasesApi = {
  async list(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/releases`);
    return data;
  },

  async get(projectKey, id) {
    const { data } = await client.get(`/api/projects/${projectKey}/releases/${id}`);
    return data;
  },

  async create(projectKey, release) {
    const { data } = await client.post(`/api/projects/${projectKey}/releases`, release);
    return data;
  },

  async update(projectKey, id, updates) {
    const { data } = await client.patch(`/api/projects/${projectKey}/releases/${id}`, updates);
    return data;
  },

  async delete(projectKey, id) {
    const { data } = await client.delete(`/api/projects/${projectKey}/releases/${id}`);
    return data;
  },

  async generate(projectKey, { tag, previousTag, filterDependabot }) {
    const body = { tag, filterDependabot };
    if (previousTag) body.previousTag = previousTag;
    const { data } = await client.post(`/api/projects/${projectKey}/releases/generate`, body);
    return data;
  },
};
